import { z } from 'zod';

const ApplicationAccountSchema = z.object({
  Alias: z.string(),
  Id: z.number(),
  Name: z.string(),
});

export const accountListSchema = z.object({
  Accounts: z.array(ApplicationAccountSchema).nullable(),
  ErrorMessage: z.string().nullable(),
});

export type ApplicationAccount = z.infer<typeof ApplicationAccountSchema>;
